import MaskedField from "../../BaseInputFields/MaskedField/MaskedField";
import {
  FieldLabeledProps,
  EmployerIdentificationNumberProps,
} from "../../types/fieldTypes";
import { formatEINSensitiveHidden } from "./utils";

export interface EmployerIdentificationNumberFieldProps
  extends EmployerIdentificationNumberProps {
  labelProps?: FieldLabeledProps;
  disableToolTip?: boolean;
}

export const EmployerIdentificationNumberField: React.FC<
  EmployerIdentificationNumberFieldProps
> = ({
  labelProps,
  label,
  description,
  value,
  disabled,
  onSubmit,
  hidden,
  errorMessages,
  isRequired,
  disableToolTip,
  defaultToSensitiveHidden = true,
}) => {
  return (
    <MaskedField
      type="Text"
      label={label}
      labelProps={labelProps}
      description={description}
      value={value}
      disabled={disabled}
      onSubmit={onSubmit}
      hidden={hidden}
      errorMessages={errorMessages}
      isRequired={isRequired}
      placeholder="12-3456789"
      mask="[0-9][0-9]-[0-9][0-9][0-9][0-9][0-9][0-9][0-9]"
      isSensitive={true}
      defaultToSensitiveHidden={defaultToSensitiveHidden}
      sensitiveHiddenFormatter={formatEINSensitiveHidden}
      disableToolTip={disableToolTip}
      cursorPositionOnFocus="start"
    />
  );
};

export default EmployerIdentificationNumberField;
